import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowLeft,
  faArrowUpRightFromSquare,
  faBookOpenCover,
  faBooks,
  faCalendarPlus,
  faChalkboardUser,
  faChevronRight,
  faCircle,
  faCircleInfo,
  faCircleNodes,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faClockRotateLeft,
  faComputer,
  faDoorOpen,
  faEdit,
  faEllipsisVertical,
  faEnvelope,
  faExclamationTriangle,
  faFileCertificate,
  faGauge,
  faGear,
  faHand,
  faHeadSideGoggles,
  faKey,
  faLayerGroup,
  faLayerPlus,
  faList,
  faListTimeline,
  faLockKeyhole,
  faMagnifyingGlass,
  faMask,
  faMedal,
  faObjectsColumn,
  faPenToSquare,
  faPersonRunning,
  faPlus,
  faQuestionCircle,
  faScreenUsers,
  faSitemap,
  faSliders,
  faSwap,
  faTimes,
  faTrashCan,
  faTriangleExclamation,
  faUserGear,
  faUserHardHat,
  faUserHeadset,
  faUserLock,
  faUserPlus,
  faUsers,
  faUsersGear,
  faUserXmark,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

export const initRegularIcons = () => {
  library.add(
    faArrowLeft,
    faArrowUpRightFromSquare,
    faBookOpenCover,
    faBooks,
    faCalendarPlus,
    faChalkboardUser,
    faChevronRight,
    faCircle,
    faCircleInfo,
    faCircleNodes,
    faCircleQuestion,
    faCircleXmark,
    faClipboardListCheck,
    faClock,
    faClockRotateLeft,
    faComputer,
    faDoorOpen,
    faEdit,
    faEllipsisVertical,
    faEnvelope,
    faExclamationTriangle,
    faFileCertificate,
    faGauge,
    faGear,
    faHand,
    faHeadSideGoggles,
    faKey,
    faLayerGroup,
    faLayerPlus,
    faList,
    faListTimeline,
    faLockKeyhole,
    faMagnifyingGlass,
    faMask,
    faMedal,
    faObjectsColumn,
    faPenToSquare,
    faPersonRunning,
    faPlus,
    faQuestionCircle,
    faScreenUsers,
    faSitemap,
    faSliders,
    faSwap,
    faTimes,
    faTrashCan,
    faTriangleExclamation,
    faUserGear,
    faUserHardHat,
    faUserHeadset,
    faUserLock,
    faUserPlus,
    faUsers,
    faUsersGear,
    faUserXmark,
    faXmark,
  );
};
